import { QR_ENTRANCE_STATUS } from '../../constants/qr';

export default () => ({
    entranceId: undefined,
    intercom: undefined,
    entranceStatus: QR_ENTRANCE_STATUS.IDLE,
    offices: [],
    selectedResident: undefined,
    searchQuery: '',
    notice: null,
});
